export const getFileType = (url: string) => {
  try {
    if (url.endsWith('.png') || url.endsWith('.jpg') || url.endsWith('.jpeg')) {
      return 'image';
    } else if (url.endsWith('.pdf')) {
      return 'pdf';
    }
    return 'unknown';
  } catch (e) {
    return `Invalid Url ${e}`;
  }
};
